import { render, staticRenderFns } from "./CannedResponsesPicker.vue?vue&type=template&id=6af6cdb3&scoped=true&"
import script from "./CannedResponsesPicker.vue?vue&type=script&lang=js&"
export * from "./CannedResponsesPicker.vue?vue&type=script&lang=js&"
import style0 from "./CannedResponsesPicker.vue?vue&type=style&index=0&id=6af6cdb3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af6cdb3",
  null
  
)

export default component.exports